import * as E from "fp-ts/Either";
import { pipe } from "fp-ts/function";
export const URI = "ValidatedM";
export const validated = (validate) => ({ _tag: "ValidatedM", validate });
export const fromValidate = validated;
export const validate = (t, x) => t.validate(x);
export const blindLookup = (k, x) => typeof x === "object" && x !== null
    ? x[k]
    : undefined;
export const map = (f) => (t) => fromValidate((x) => E.map(f)(validate(t, x)));
export const fail = (err) => fromValidate((_) => E.left(err));
// Applicative
export const of = (a) => fromValidate((_) => E.right(a));
export const ap = (t) => (f) => fromValidate((x) => pipe(f.validate(x), E.ap(t.validate(x))));
// Chain
export const chain = (f) => (t) => fromValidate((x) => {
    // Validate using Validated<A>
    const ea = validate(t, x);
    // Create Validated<B> based on value of previous validation
    // Rerun validation with new Validated<B>, or pass validation errors
    return E.chain((y) => validate(f(y), x))(ea);
});
export const Functor = {
    URI,
    map: (fa, f) => pipe(fa, map(f)),
};
export const Apply = {
    URI,
    map: (fa, f) => pipe(fa, map(f)),
    ap: (fab, fa) => pipe(fab, ap(fa)),
};

